import { render, staticRenderFns } from "./ItemcategoriesComponent.vue?vue&type=template&id=7e4de9a4&scoped=true&"
import script from "./ItemcategoriesComponent.vue?vue&type=script&lang=js&"
export * from "./ItemcategoriesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4de9a4",
  null
  
)

export default component.exports